import { render, staticRenderFns } from "./EvolutionDashboardHeader.vue?vue&type=template&id=988460ca&scoped=true&"
import script from "./EvolutionDashboardHeader.vue?vue&type=script&lang=js&"
export * from "./EvolutionDashboardHeader.vue?vue&type=script&lang=js&"
import style0 from "./EvolutionDashboardHeader.vue?vue&type=style&index=0&id=988460ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988460ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('988460ca')) {
      api.createRecord('988460ca', component.options)
    } else {
      api.reload('988460ca', component.options)
    }
    module.hot.accept("./EvolutionDashboardHeader.vue?vue&type=template&id=988460ca&scoped=true&", function () {
      api.rerender('988460ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/EvolutionDashboardHeader.vue"
export default component.exports